import React from 'react';

const BriefStepFieldPair: React.FunctionComponent = props => (
    <div className="fieldset-pair">{props.children}</div>
);

export default BriefStepFieldPair;
